<template>
  <!-- <div class="root">  -->
  <div class="topTab">
    <div class="isNavMaxShow"  :class="{scollBack: scrolled}" >
      <div><img src="../assets/nav-img2.png" /></div>
      <div class="topInfo">
        <ul>
          <li><router-link to="/">公司介绍</router-link></li>
          <li><router-link to="/product">产品中心</router-link></li>
          <li><router-link to="/examp">案例展示</router-link></li>
          <li><router-link to="/case">资源合作</router-link></li>
          <li><router-link to="/welfare">爱心公益</router-link></li>
        </ul>
      </div>
    </div>
    <div class="isNavMInShow">
      <div class="phoneStyle">
        <div class="headerIcon headerPhoneIcon1">
          <img src="../assets/nav-img2.png" />
        </div>
        <div class="headerIcon2 headerPhoneIcon2" @click="changeBackColor">
          <img src="../assets/icon7.png" v-if="isShowPhoneMenu==true" />
          <i class="el-icon-close closePhone" v-if="isShowPhoneMenu==false"></i>
        </div>
      </div>
    </div>
    <div class="phoneMenu" v-if="!isShowPhoneMenu">
      <div @click="goHome">公司介绍</div>
      <div @click="goPro">产品中心</div>
      <div @click="goTeam">案例展示</div>
      <div @click="goNews">资源合作</div>
      <div @click="goCon">爱心公益</div>
    </div>
  </div>
  <!-- </div> -->
</template>
<script>
  export default {
    name: 'Tabbar',
    data() {
      return {
        isShowPhoneMenu: true,
        scrolled: false,
      }
    },
    mounted() {  // 监听滚动事件
      window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
      // 组件销毁时移除滚动事件监听
      window.removeEventListener('scroll', this.handleScroll);
    },
    // 方法体
    methods: {

      handleScroll() {
        // 如果页面滚动距离大于 0，则设置 scrolled 为 true
        // this.scrolled = window.scrollY > 0;
        if (window.scrollY == 0) {
          this.backColor = true;
          this.scrolled=false;
        } else {
          this.backColor = false;
          this.scrolled=true;
        }
      },
      goHome() {
        this.$router.push({
          path: '/'
        })
        this.isShowPhoneMenu = !this.isShowPhoneMenu;
      },
      goPro() {
        this.$router.push({
          path: '/product'
        })
        this.isShowPhoneMenu = !this.isShowPhoneMenu;
      },
      goTeam() {
        this.$router.push({
          path: '/examp'
        })
        this.isShowPhoneMenu = !this.isShowPhoneMenu;
      },
      goNews() {
        this.$router.push({
          path: '/case'
        })
        this.isShowPhoneMenu = !this.isShowPhoneMenu;
      },
      goCon() {
        this.$router.push({
          path: '/welfare'
        })
        this.isShowPhoneMenu = !this.isShowPhoneMenu;
      },
      changeBackColor() {

        this.isShowPhoneMenu = !this.isShowPhoneMenu;
      }
    },

  }
</script>
<style scoped>
  
  .scollBack {
    background-color: #ffffff;
  }
  ul {
    list-style-type: none;
    display: flex;
  }

  ul li {
    list-style-type: none;
  }

  ul li a {
    color: #333333;
    text-decoration: none;
    font-size: 1vw;
    font-weight: 600;
    margin-right: 3.5vw;
  }

  /* 针对电脑端 */
  @media screen and (min-width: 1024px) {
    .isNavMaxShow {
      width: 100%;
      height: auto;
      position: fixed;
      top: 0;
      left: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      z-index: 10;
    }

    .isNavMaxShow>div {
      margin: 1vw 8vw;
    }

    .isNavMInShow {
      display: none;
    }
  }

  /* 针对手机端 */
  @media screen and (max-width: 1023px) {
    .isNavMaxShow {
      display: none;
    }

    .phoneStyle {
      width: 100%;
      position: fixed;
      top: 0;
      left: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      z-index: 10;
      padding: 3vw 0vw;
      background-color: white;
    }

    .isNavMInShow {
      width: 100%;
    }


    .headerIcon {
      width: 35vw;
      height: 6vw;
    }

    .headerIcon2 {
      width: 4vw;
      height: 4vw;
    }
  }

  .phoneMenu {
    position: fixed;
    width: 100%;
    top: 11vw;
    left: 0;
    z-index: 99;
    background-color: #29B8F8;
    /* padding-top: 7vw; */
    text-align: left;
    color: white;
  }

  .closePhone {
    font-weight: bold;
    color: #29B8F8;
    font-size: 3vw;
  }

  .phoneMenu>div {
    padding: 2vw 0vw 0.5vw 0vw;
    margin-left: 4vw;
    border-bottom: 0.1px solid white;
  }

  .phoneMenu>div:last-child {
    border-bottom: none;
    padding-bottom: 5vw;
  }

  .phone-menu-active {
    background-color: #29B8F8 !important;
  }

  .headerPhone {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .headerPhoneIcon1 {
    margin-left: 4vw;
  }

  .headerPhoneIcon2 {
    margin-right: 4vw;
  }
</style>